import React from 'react';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { LineContent, LineContainer } from './commonStyles';

const TableByDevice = {
  desktop: [
    {
      firstWidth: '158px',
      secondWidth: '100px',
      thirdWidth: '87px',
      height: '19px',
      rowId: 'skeleton-table-row-1'
    },
    {
      firstWidth: '163px',
      secondWidth: '100px',
      thirdWidth: '87px',
      height: '19px',
      rowId: 'skeleton-table-row-2'
    },
    {
      firstWidth: '163px',
      secondWidth: '100px',
      thirdWidth: '87px',
      height: '20px',
      rowId: 'skeleton-table-row-3'
    },
    {
      firstWidth: '136px',
      secondWidth: '100px',
      thirdWidth: '87px',
      height: '19px',
      rowId: 'skeleton-table-row-4'
    },
    {
      firstWidth: '163px',
      secondWidth: '100px',
      thirdWidth: '87px',
      height: '19px',
      rowId: 'skeleton-table-row-5'
    },
    {
      firstWidth: '136px',
      secondWidth: '100px',
      thirdWidth: '87px',
      height: '19px',
      rowId: 'skeleton-table-row-6'
    }
  ],
  tablet: [
    {
      firstWidth: '122px',
      secondWidth: '77px',
      thirdWidth: '68px',
      height: '19px',
      rowId: 'skeleton-table-row-7'
    },
    {
      firstWidth: '126px',
      secondWidth: '77px',
      thirdWidth: '68px',
      height: '19px',
      rowId: 'skeleton-table-row-8'
    },
    {
      firstWidth: '126px',
      secondWidth: '77px',
      thirdWidth: '68px',
      height: '20px',
      rowId: 'skeleton-table-row-9'
    },
    {
      firstWidth: '105px',
      secondWidth: '77px',
      thirdWidth: '68px',
      height: '19px',
      rowId: 'skeleton-table-row-10'
    },
    {
      firstWidth: '126px',
      secondWidth: '77px',
      thirdWidth: '68px',
      height: '19px',
      rowId: 'skeleton-table-row-11'
    },
    {
      firstWidth: '105px',
      secondWidth: '77px',
      thirdWidth: '68px',
      height: '19px',
      rowId: 'skeleton-table-row-12'
    }
  ],
  mobile: [
    {
      firstWidth: '55px',
      secondWidth: '48px',
      thirdWidth: '48px',
      height: '19px',
      rowId: 'skeleton-table-row-13'
    },
    {
      firstWidth: '124px',
      secondWidth: '48px',
      thirdWidth: '48px',
      height: '19px',
      rowId: 'skeleton-table-row-14'
    },
    {
      firstWidth: '124px',
      secondWidth: '48px',
      thirdWidth: '48px',
      height: '20px',
      rowId: 'skeleton-table-row-15'
    },
    {
      firstWidth: '103px',
      secondWidth: '48px',
      thirdWidth: '48px',
      height: '19px',
      rowId: 'skeleton-table-row-16'
    },
    {
      firstWidth: '124px',
      secondWidth: '48px',
      thirdWidth: '48px',
      height: '19px',
      rowId: 'skeleton-table-row-17'
    },
    {
      firstWidth: '103px',
      secondWidth: '48px',
      thirdWidth: '48px',
      height: '19px',
      rowId: 'skeleton-table-row-18'
    }
  ]
};

const TableArea = ({ device }) => {
  const createRows = deviceType => {
    return TableByDevice[deviceType || 'desktop'];
  };
  const tableRows = createRows(device);
  return (
    <Container>
      <Title device={device}>
        <div>
          <LineContent width='248px' marginBottom='19px' />
          <LineContent width='331px' />
        </div>
        <TitleRight className={`skeleton-title-right-${device}`}>
          <LineContent width='137px' />
          <LineContent width='137px' />
        </TitleRight>
      </Title>
      <Table>
        <TableHeader>
          <LineContainer width='298px'>
            <LineContent width='111px' height='19px' />
            <LineContent width='136px' height='19px' />
          </LineContainer>
        </TableHeader>
        {tableRows.map(row => (
          <TableRow key={row.rowId}>
            <LineContent width={row.firstWidth} height='19px' />
            <LineContainer width='50%'>
              <LineContent width={row.secondWidth} height='19px' />
              <LineContent width={row.thirdWidth} height='19px' />
            </LineContainer>
          </TableRow>
        ))}
      </Table>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: ${({ device }) => device === 'mobile' && 'column'};
`;

const TitleRight = styled.div`
  width: 267px;
  height: 49px;
  display: flex;
  background-color: ${select('middleGray')};
  border-radius: 12px;
  > div {
    display: none;
  }
  &.skeleton-title-right-mobile {
    background-color: white;
    border: 1px solid ${select('middleGray')};
    width: 328px;
    align-items: center;
    justify-content: space-between;
    box-shadow: -6px 0px 34px 7px rgba(196, 196, 196, 0.12);
    margin-top: 35px;
    padding: 0 15px;
    > div {
      display: inline-block;
    }
  }
`;

const Table = styled.div`
  overflow: hidden;
  width: 100%;
  border: 1px solid ${select('middleGray')};
  border-radius: 4px;
  margin-top: 27px;
  display: flex;
  flex-direction: column;
`;

const TableHeader = styled.div`
  overflow: hidden;
  width: 100%;
  border-bottom: 1px solid ${select('grayLight')};
  height: 72px;
  padding: 0 33px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const TableRow = styled.div`
  overflow: hidden;
  width: 100%;
  height: 72px;
  padding: 0 33px 0 27px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default React.memo(TableArea);
